import { Configuration, PopupRequest, PublicClientApplication } from '@azure/msal-browser';

// MSAL configuration for Entra ID
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '5ec581da-e54b-493e-a824-3db3ca6dd1a1',
    authority: import.meta.env.VITE_AZURE_AUTHORITY || 'https://login.microsoftonline.com/common',
    redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin + '/auth/callback',
    postLogoutRedirectUri: import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // LogLevel.Error
            console.error(message);
            return;
          case 1: // LogLevel.Warning
            console.warn(message);
            return;
          case 2: // LogLevel.Info
            console.info(message);
            return;
          case 3: // LogLevel.Verbose
            console.debug(message);
            return;
        }
      }
    }
  }
};

// Login request configuration
export const loginRequest: PopupRequest = {
  scopes: ['openid', 'profile', 'email'],
  prompt: 'select_account'
};

// Shared MSAL instance — single instance avoids cache conflicts
export const msalInstance = new PublicClientApplication(msalConfig);

// API configuration
export const apiConfig = {
  baseUrl: import.meta.env.VITE_API_URL_PRODUCTION || 'https://app-anchor-api-production.azurewebsites.net',
};